import { render, staticRenderFns } from "./MessageComponent.vue?vue&type=template&id=a1c0dccc&scoped=true"
import script from "./MessageComponent.vue?vue&type=script&lang=js"
export * from "./MessageComponent.vue?vue&type=script&lang=js"
import style0 from "./MessageComponent.vue?vue&type=style&index=0&id=a1c0dccc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c0dccc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1c0dccc')) {
      api.createRecord('a1c0dccc', component.options)
    } else {
      api.reload('a1c0dccc', component.options)
    }
    module.hot.accept("./MessageComponent.vue?vue&type=template&id=a1c0dccc&scoped=true", function () {
      api.rerender('a1c0dccc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/MessageComponent.vue"
export default component.exports